export interface AAEventConfig {
  eventType: 'click' | 'screen';
  ctEvent: boolean;
  appsflyerEvent: boolean;
  appEventName?: string; // Optional alternate event name for sendToApp
}

export const AA_JOURNEY_EVENT_MAPPING: Record<string, AAEventConfig> = {
  IFRAME_SUCCESS: {
    eventType: 'screen',
    ctEvent: true,
    appsflyerEvent: true,
  },
  IFRAME_FAILED: {
    eventType: 'screen',
    ctEvent: true,
    appsflyerEvent: false,
  },
  LOGIN_OTP_SENT: {
    eventType: 'click',
    ctEvent: true,
    appsflyerEvent: false,
  },
  LOGIN_OTP_SENT_FAILED: {
    eventType: 'click',
    ctEvent: false,
    appsflyerEvent: false,
  },
  SIGNUP_OTP_SENT: {
    eventType: 'click',
    ctEvent: true,
    appsflyerEvent: false,
  },
  SIGNUP_OTP_SENT_FAILED: {
    eventType: 'click',
    ctEvent: false,
    appsflyerEvent: false,
  },
  RESENT_OTP: {
    eventType: 'click',
    ctEvent: false,
    appsflyerEvent: false,
  },
  USER_LOGGEDIN: {
    eventType: 'screen',
    ctEvent: true,
    appsflyerEvent: false,
  },
  USER_SIGNEDUP: {
    eventType: 'screen',
    ctEvent: true,
    appsflyerEvent: false,
  },
  USER_LOGIN_FAILED: {
    eventType: 'click',
    ctEvent: false,
    appsflyerEvent: false,
  },
  USER_SIGNUP_FAILED: {
    eventType: 'click',
    ctEvent: false,
    appsflyerEvent: false,
  },
  LINKED_ACCOUNT_FOUND: {
    eventType: 'screen',
    ctEvent: false,
    appsflyerEvent: false,
  },
  GET_LINKED_ACCOUNT_FAILED: {
    eventType: 'click',
    ctEvent: false,
    appsflyerEvent: false,
  },
  NO_LINKED_ACCOUNT_FOUND: {
    eventType: 'screen',
    ctEvent: false,
    appsflyerEvent: false,
  },
  ACCOUNTS_DISCOVERED: {
    eventType: 'screen',
    ctEvent: false,
    appsflyerEvent: false,
  },
  ACCOUNTS_DISCOVERY_FAILED: {
    eventType: 'screen',
    ctEvent: false,
    appsflyerEvent: false,
  },
  NO_ACCOUNTS_FOUND: {
    eventType: 'screen',
    ctEvent: false,
    appsflyerEvent: false,
  },
  LINKING_ACCOUNT_OTP_SENT: {
    eventType: 'click',
    ctEvent: true,
    appsflyerEvent: false,
  },
  LINKING_ACCOUNT_OTP_FAILED: {
    eventType: 'click',
    ctEvent: false,
    appsflyerEvent: false,
  },
  LINKING_ACCOUNT_OTP_RESENT: {
    eventType: 'click',
    ctEvent: false,
    appsflyerEvent: false,
  },
  LINKING_ACCOUNT_SUCCESS: {
    eventType: 'screen',
    ctEvent: true,
    appsflyerEvent: false,
  },
  LINKING_ACCOUNT_FAILED: {
    eventType: 'click',
    ctEvent: false,
    appsflyerEvent: false,
  },
  CONSENT_APPROVED_SUCCESS: {
    eventType: 'screen',
    ctEvent: true,
    appsflyerEvent: false,
  },
  CONSENT_REJECTED_SUCCESS: {
    eventType: 'screen',
    ctEvent: true,
    appsflyerEvent: false,
  },
  CONSENT_APPROVED_FAILED: {
    eventType: 'click',
    ctEvent: false,
    appsflyerEvent: false,
  },
  CONSENT_REJECTED_FAILED: {
    eventType: 'click',
    ctEvent: false,
    appsflyerEvent: false,
  },
  CONSENT_NOT_IN_PENDING_STATE: {
    eventType: 'click',
    ctEvent: false,
    appsflyerEvent: false,
  },
  RESEND_OTP_FAILED: {
    eventType: 'click',
    ctEvent: false,
    appsflyerEvent: false,
  },
  LINKING_ACCOUNT_RESEND_OTP_FAILED: {
    eventType: 'click',
    ctEvent: false,
    appsflyerEvent: false,
  },
  NO_LINKED_ACCOUNTS_FOUND_ENDING_WITH: {
    eventType: 'screen',
    ctEvent: false,
    appsflyerEvent: false,
  },
  NO_ACCOUNTS_DISCOVERED_ENDING_WITH: {
    eventType: 'screen',
    ctEvent: false,
    appsflyerEvent: false,
  },
  ALL_ACCOUNTS_ALREADY_LINKED: {
    eventType: 'click',
    ctEvent: false,
    appsflyerEvent: false,
  },
  LINK_ACCOUNT_BUTTON_CLICKED: {
    eventType: 'click',
    ctEvent: true,
    appsflyerEvent: false,
  },
  LINK_ACCOUNT_RESEND_OTP_BUTTON_CLICKED: {
    eventType: 'click',
    ctEvent: false,
    appsflyerEvent: false,
  },
  LINK_ACCOUNT_BACK_BUTTON_CLICKED: {
    eventType: 'click',
    ctEvent: false,
    appsflyerEvent: false,
  },
  VERIFY_BANK_OTP_BUTTON_CLICKED: {
    eventType: 'click',
    ctEvent: false,
    appsflyerEvent: false,
  },
  VERIFY_BANK_OTP_BACK_BUTTON_CLICKED: {
    eventType: 'click',
    ctEvent: false,
    appsflyerEvent: false,
  },
  APPROVE_CONSENT_BUTTON_CLICKED: {
    eventType: 'click',
    ctEvent: true,
    appsflyerEvent: false,
  },
  REJECT_CONSENT_BUTTON_CLICKED: {
    eventType: 'click',
    ctEvent: true,
    appsflyerEvent: false,
  },
  CONSENT_DETAILS_FETCHED: {
    eventType: 'screen',
    ctEvent: true,
    appsflyerEvent: true,
  },
  CONSENT_DETAILS_FETCHING_FAILED: {
    eventType: 'click',
    ctEvent: false,
    appsflyerEvent: false,
  },
  CONSENT_DETAILS_GET_LINKED_ACCOUNT_FAILED: {
    eventType: 'click',
    ctEvent: false,
    appsflyerEvent: false,
    appEventName: 'CONSENT_DETAILS_GET_LINK_ACC_FAILED',
  },
  GET_FIU_NAME_FAILED: {
    eventType: 'click',
    ctEvent: false,
    appsflyerEvent: false,
  },
  JOURNEY_COMPLETED: {
    eventType: 'screen',
    ctEvent: true,
    appsflyerEvent: true,
  },
  SECONDARY_IDENTIFIERS_FETCHED: {
    eventType: 'screen',
    ctEvent: false,
    appsflyerEvent: false,
  },
  SECONDARY_IDENTIFIERS_FETCHING_FAILED: {
    eventType: 'click',
    ctEvent: false,
    appsflyerEvent: false,
  },
  JOURNEY_SKIPPED: {
    eventType: 'click',
    ctEvent: true,
    appsflyerEvent: false,
  },
  NO_ACCOUNT_DISCOVERED: {
    eventType: 'screen',
    ctEvent: false,
    appsflyerEvent: false,
  },
  SKIP_FIP_CLICKED: {
    eventType: 'click',
    ctEvent: false,
    appsflyerEvent: false,
  },
};

export default AA_JOURNEY_EVENT_MAPPING;
